var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadData)?_c('DatatableV2',{attrs:{"displayTitle":false,"flat":true,"url":_vm.apiUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }